/**
 * @deprecated This function is deprecated and will be removed in the next major version.
 */
export const useTracking = (_props) => {
    return (_index, _isOpen) => {
        // No implementation for this function, must implement own tracking logic
    };
};
